import React from 'react';

const dates = [
  {
    label: "Paper Submission Deadline:",
    date: "31st July, 2025",
    otherdate:"23rd Feb, 2027",
  },
  {
    label: "Acceptance Notification:",
    date: "8th Sept, 2025",
    otherdate:"3rd May, 2027",
  },
  {
    label: "Camera Ready Paper Submission Deadline:",
    date: "8th Oct, 2025",
    otherdate:"8th June, 2027",
  },
  {
    label: "Registration Deadline:",
    date: "8th Oct, 2025",
    otherdate:"18th June, 2027"
  },
  {
    label: "Conference Date:",
    date: "18th - 20th Mar, 2026",
    otherdate:"8th - 10th Jul, 2027"
  }
];

function PaperSubmission() {
  return (
    <div className="w-full min-h-screen px-4 sm:px-6 lg:px-8 pt-5 sm:pt-10">  {/* Added pt-20 sm:pt-24 for top margin */}
      <h2 className="text-2xl sm:text-3xl uppercase lg:text-3xl font-bold sm:mb-10 mb-4 text-center">
            Paper Submission
          </h2>
      <div className="max-w-7xl mx-auto">
      
        <div className="bg-gray-100 rounded-lg shadow-lg p-4 sm:p-6 lg:p-8">
          
          {/* Guidelines Section */}
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-4">
            Paper Submission Guidelines:
          </h2>
          
          <ul className="space-y-3 mb-8 text-sm sm:text-base lg:text-lg">
            <li className="flex flex-col sm:flex-row sm:items-center gap-2">
              <span>Paper should be in IEEE format.</span>
              <a 
                href="https://www.ieee.org/conferences/publishing/templates" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800 underline inline-block"
              >
                IEEE Format
              </a>
            </li>
            
            <li className="flex flex-col sm:flex-row sm:items-center gap-2">
              <span>Paper to be submitted through Microsoft CMT.</span>
              <a 
                href="https://cmt3.research.microsoft.com/IETACS2027" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800 underline inline-block"
              >
                https://cmt3.research.microsoft.com/IETACS2027
              </a>
            </li>
			
			<li className="flex flex-col sm:flex-row sm:items-center gap-2">
              <em>(The Microsoft CMT service was used for managing the peer-reviewing process for this conference. This service was provided for free by Microsoft and they bore all expenses, including costs for Azure cloud services as well as for software development and support.)</em>
            </li>
            
            <li>Paper length: preferably 6-7 pages. Thereafter 50 USD per page.</li>
            <li>Plagiarism should not be more than 10% (5% from single source)</li>
            <li>AI content: NIL</li>
          </ul>

          {/* Important Dates Section */}
          <div className="mt-8">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-4">
              Important Dates:
            </h2>
            
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <tbody>
                  {dates.map((item, index) => (
                    <tr 
                      key={index} 
                      className={`
                        border-b border-gray-300
                        hover:bg-gray-50 transition-colors
                        ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                      `}
                    >
                      <td className="py-3 px-4 text-sm sm:text-base lg:text-lg font-medium">
                        {item.label}
                      </td>
                      {/* <td className="py-3 px-4 text-sm sm:text-base lg:text-lg">
                        {index < 4 ? <strike style={{ textDecoration: 'line-through', textDecorationColor: 'red'}}>{item.date}</strike> : item.date}
                      </td> */ }
                      <td className="py-1.5 px-3 text-xs md:text-sm lg:text-base font-medium text-right">
                        <span>{item.otherdate}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default PaperSubmission;